enum ProductType {
  Code = "Code",
  External = "External"
}

export default ProductType
